var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.149,
    height: 17.392,
    viewBox: "0 0 17.149 17.392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1100.729 -483.039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.876,0h1.076l-.879,11.432a1.61,1.61,0,0,1-1.148,1.42v1.139h-9.9V12.853a1.61,1.61,0,0,1-1.148-1.42L0,0H1.076l.873,11.35a.537.537,0,0,0,.535.5H3.1v1.073h7.751V11.845h.616a.537.537,0,0,0,.535-.5Z",
    transform: "translate(1102.334 486.439)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H1.073V7.513H0Z",
    transform: "translate(1107.699 488.586)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H1.073V7.513H0Z",
    transform: "translate(1109.846 488.586)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.149,2.85V1.425A.51.51,0,0,0,15.611.95H9.689V.475A.51.51,0,0,0,9.151,0H7A.51.51,0,0,0,6.46.475V.95H.538A.51.51,0,0,0,0,1.425V2.85Z",
    transform: "translate(1101.229 483.539)",
    fill: "none",
    stroke: "#0c4767",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash_icon.d94a0b81a2c5cda91e850a45b8df7b85.svg";
export { ForwardRef as ReactComponent };